import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Ban, Check, Info } from "lucide-react";
import { consentSourceLabel } from "./crm/SmsConsentPanel";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { timeZone: "America/Los_Angeles", month: "2-digit", day: "2-digit", year: "numeric" }) : "");

/* 发送框柔性提示：按号码查同意状态（不拦截）。unknown 淡黄 · declined 琥珀 · opted_out 深灰（Twilio 会拦截） · agreed 淡绿 */
export function SmsConsentHint({ api, zh, phone, email, testid = "sms-consent-hint" }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const okPhone = phone && String(phone).replace(/\D/g, "").length >= 7;
    const okEmail = !phone && email && String(email).includes("@");
    if (!okPhone && !okEmail) { setD(null); return; }
    let live = true;
    api.get("/sms-consent/lookup", { params: okPhone ? { phone } : { email } }).then(({ data }) => live && setD(data)).catch(() => live && setD(null));
    return () => { live = false; };
  }, [phone, email]); // eslint-disable-line
  if (!d) return null;
  const T = (z, e) => (zh ? z : e);
  const who = d.name ? `${d.name} · ` : "";
  if (d.emailStatus) {
    if (d.emailStatus !== "unsubscribed") return null;
    return (
      <div className="flex items-start gap-1.5 text-[11px] border rounded-md px-2 py-1.5 bg-orange-50 border-orange-200 text-orange-800" data-testid={testid} data-status="unsubscribed">
        <AlertTriangle className="h-3.5 w-3.5 shrink-0 mt-0.5" />
        <span className="min-w-0">{who}{T("该邮箱已点击退订，营销 / 培育邮件不再发送；合同 / 付款等必要事项可继续（不拦截）", "This address unsubscribed — no marketing / nurture emails; essential project emails still allowed (not blocked)")}{d.at ? ` · ${fmt(d.at)}` : ""}{d.link && <Link to={d.link} className="ml-1 underline underline-offset-2" data-testid={`${testid}-link`}>{T("查看", "View")}</Link>}</span>
      </div>
    );
  }
  const ui = {
    unknown: { cls: "bg-amber-50/80 border-amber-200 text-amber-800", Icon: Info, text: T("尚未记录该号码的短信同意（不影响发送）。建议在客户线索页记录客户口头 / 书面同意。", "No SMS consent on record for this number (sending is not blocked). Consider recording consent on the lead.") },
    agreed: { cls: "bg-emerald-50/70 border-emerald-200 text-emerald-700", Icon: Check, text: `${who}${T("已同意接收短信", "SMS consent on record")}${d.source ? ` · ${consentSourceLabel(d.source, zh)}` : ""}${d.at ? ` · ${fmt(d.at)}` : ""}` },
    declined: { cls: "bg-orange-50 border-orange-200 text-orange-800", Icon: AlertTriangle, text: `${who}${T("已记录为拒绝接收短信，建议改用电话 / 邮件（不拦截发送）", "Marked as declined — consider phone / email instead (not blocked)")}${d.source ? ` · ${consentSourceLabel(d.source, zh)}` : ""}${d.at ? ` · ${fmt(d.at)}` : ""}` },
    opted_out: { cls: "bg-slate-800 border-slate-700 text-white", Icon: Ban, text: `${who}${T("该号码已回复 STOP 退订，Twilio 会拦截发送；请改用电话 / 邮件", "This number texted STOP — Twilio will block delivery; use phone / email")}${d.optoutAt ? ` · ${fmt(d.optoutAt)}` : ""}` },
  }[d.status] || null;
  if (!ui) return null;
  return (
    <div className={`flex items-start gap-1.5 text-[11px] border rounded-md px-2 py-1.5 ${ui.cls}`} data-testid={testid} data-status={d.status}>
      <ui.Icon className="h-3.5 w-3.5 shrink-0 mt-0.5" />
      <span className="min-w-0">{ui.text}{d.link && d.kind !== "none" && <Link to={d.link} className="ml-1 underline underline-offset-2" data-testid={`${testid}-link`}>{T("查看", "View")}</Link>}</span>
    </div>
  );
}
